import React from 'react';
import styled from 'styled-components';
import { breakpoint } from '../../../lib/style/ThemeStyle';

import { BackButton } from '../atom/BackButton';
import { Text } from '../atom/Text';

export const SubHeader = ({ title = '' }) => {
  return (
    <Container>
      <BackButton />
      <Text size={18} weight="bold">
        {title}
      </Text>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  margin-top: 2.875rem;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 0.6875rem 1.25rem;
  justify-content: center;
  width: 100%;
  max-width: ${breakpoint}px;
  border-bottom: 1px solid ${(props) => props.theme.color.brownGrey};
  color: ${(props) => props.theme.color.darkest};
  background: ${(props) => props.theme.color.background};

  i {
    position: absolute;
    left: 1.25rem;
  }
`;
